import { cookie } from './cookie';

export const OE_SSO_TOKEN_COOKIE_NAME = 'OESSOTOK';

export const oeSsoCookieStorage = cookie(OE_SSO_TOKEN_COOKIE_NAME);
